import StakeholderPage from 'components/Dashboard/StakeHolders/StakeholderPage';
import React from 'react';
import InfluenceContentContainer from 'components/Dashboard/UserContent/InfluenceContentContainer';
import ContentControl from 'components/Dashboard/ContentControl';
import ParliamentLiveEventView from 'components/Dashboard/ParliamentLive/ParliamentLiveEventView';
import { Navigate, useLocation, useParams } from 'react-router';

// Legacy /library-material/{id}/{title} URLs pre-date lords content, so they are always commons
const LibraryMaterialRoute = () => {
  const { type } = useParams();
  const location = useLocation();
  if (!isNaN(parseInt(type))) {
    return (
      <Navigate
        replace
        to={`${location.pathname.replace('/library-material/', '/library-material/commons/')}${location.search}${location.hash}`}
      />
    );
  }
  return <ContentControl />;
};

// Static, no dependency on props/state - built once at module load instead of on every
// ContentApp render (this was showing up as real, repeated self-time in the profiler).
const ContentMainRoutesMapping = {
  'key-updates': {
    element: <ContentControl />,
  },
  consultations: {
    element: <ContentControl />,
  },
  legislation: {
    element: <ContentControl />,
    parameters: ['type', 'id', 'title'],
  },
  'parliamentary-record': {
    element: <ContentControl />,
    parameters: ['type', 'id', 'title'],
  },
  'committee-publication': {
    element: <ContentControl />,
    parameters: ['id', 'type', 'title'],
  },
  'library-material': {
    element: <LibraryMaterialRoute />,
    parameters: ['type', 'id', 'title'],
  },
  stakeholders: {
    element: <StakeholderPage />,
    parameters: ['id', 'name', 'contentType'],
  },
  'policy-asks': {
    element: <InfluenceContentContainer page={'policy-asks'} />,
  },
  'briefing-material': {
    element: <InfluenceContentContainer page={'briefing-material'} />,
  },
  'news-release': {
    element: <InfluenceContentContainer page={'news-release'} />,
  },
  research: {
    element: <InfluenceContentContainer page={'research'} />,
  },
  'parliament-live': {
    element: <ParliamentLiveEventView />,
    parameters: ['event'],
  },
  'regulation-docket': {
    element: <ContentControl />,
  },
  'regulation-document': {
    element: <ContentControl />,
  },
  'regulation-comment': {
    element: <ContentControl />,
  },
};

const useContentMainRoutesMapping = () => {
  return { ContentMainRoutesMapping };
};

export default useContentMainRoutesMapping;
